import React, { useState } from 'react';
import { auth, db } from './firebase'; // 🌟 db 추가!
import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { ref, get } from "firebase/database"; // 🌟 데이터를 읽어오는 get 도구 추가!
import { useNavigate } from 'react-router-dom';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        const user = userCredential.user;

        // 1. 이메일 인증 검사
        if (!user.emailVerified) {
          alert("📧 이메일 인증이 완료되지 않았습니다! 메일함에서 인증 링크를 클릭해주세요.");
          signOut(auth); 
          return; 
        }

        // 2. 🌟 데이터베이스에서 이 사람의 '역할(role)'을 읽어옵니다.
        const userRef = ref(db, 'users/' + user.uid);
        get(userRef).then((snapshot) => {
          if (snapshot.exists()) {
            const userData = snapshot.val();
            
            // 역할에 따라 길을 안내합니다!
            if (userData.role === 'teacher') {
              alert("👨‍🏫 선생님으로 로그인하셨습니다.");
              navigate('/teacher');
            } else {
              alert("👨‍🎓 학생으로 로그인하셨습니다.");
              navigate('/student');
            }
          } else {
            // 혹시 데이터가 없는 옛날 가입자라면 기본적으로 학생으로 보냅니다.
            navigate('/student');
          }
        }).catch((error) => {
          console.error("데이터 읽기 에러:", error);
          navigate('/student');
        });
      })
      .catch((error) => alert("로그인 실패: 이메일과 비밀번호를 확인하세요."));
  };

  return (
    <div className="container" style={{ textAlign: 'center', marginTop: '10vh', fontFamily: 'sans-serif' }}>
      <h1 style={{ color: '#2c3e50' }}>🧪 시약 관리 시스템</h1>
      <p style={{ color: '#7f8c8d' }}>로그인하여 서비스를 이용해주세요.</p>

      <form onSubmit={handleLogin} style={{ display: 'inline-block', textAlign: 'left', padding: '30px', border: '1px solid #ddd', borderRadius: '15px', backgroundColor: 'white', boxShadow: '0 4px 10px rgba(0,0,0,0.1)', width: '300px' }}>
        
        <div style={{ marginBottom: '15px' }}>
          <label style={{ fontWeight: 'bold', fontSize: '0.9em' }}>이메일</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required style={{ width: '100%', padding: '10px', marginTop: '5px', boxSizing: 'border-box', borderRadius: '5px', border: '1px solid #ccc' }} />
        </div>
        
        <div style={{ marginBottom: '25px' }}>
          <label style={{ fontWeight: 'bold', fontSize: '0.9em' }}>비밀번호</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required style={{ width: '100%', padding: '10px', marginTop: '5px', boxSizing: 'border-box', borderRadius: '5px', border: '1px solid #ccc' }} />
        </div>
        
        <button type="submit" style={{ width: '100%', padding: '12px', backgroundColor: '#3498db', color: 'white', border: 'none', borderRadius: '5px', fontWeight: 'bold', cursor: 'pointer', fontSize: '1em' }}>
          로그인
        </button>

        <div style={{ marginTop: '20px', textAlign: 'center', fontSize: '0.9em', color: '#7f8c8d' }}>
          아직 계정이 없으신가요?<br />
          <button type="button" onClick={() => navigate('/signup')} style={{ marginTop: '10px', background: 'none', border: 'none', color: '#e74c3c', cursor: 'pointer', fontWeight: 'bold', textDecoration: 'underline' }}>
            10초만에 회원가입하기
          </button>
        </div>
      </form>
    </div>
  );
}

export default Login;